import {make} from "vuex-pathify"

const state = {
    isLoading: false,
    // Webhook being created, edited or viewed
    form: {},
    // Webhook list
    page: {
        data: [],
        meta: {}
    },
    // Available events, cached between the form pages
    availableEvents: [],
}

const mutations = make.mutations(state)

const actions = {
    loading({commit}) {
        commit('SET_IS_LOADING', true)
    },
    loaded({commit}) {
        commit('SET_IS_LOADING', false)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
